webpackJsonp([118157794583282],{

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(8);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoriesIndexPage = function (_Component) {
	  _inherits(StoriesIndexPage, _Component);
	
	  function StoriesIndexPage() {
	    _classCallCheck(this, StoriesIndexPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  StoriesIndexPage.prototype.render = function render() {
	    var stories = [{
	      link: 'richard-overton',
	      title: 'Mr. Richard Overton',
	      imgSizes: this.props.data.richardOverton.sizes,
	      imgTitle: 'Richard Overton, World War II Veteran'
	    }, {
	      link: 'campsey',
	      title: 'The Campsey Family',
	      imgSizes: this.props.data.campsey.sizes,
	      imgTitle: 'The Campsey Family'
	    }, {
	      link: 'jessica-foster',
	      title: 'Jessica Foster',
	      imgSizes: this.props.data.jessicaFoster.sizes,
	      imgTitle: 'Jessica Foster, school teacher'
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'container p-5' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Affordable Housing in Your Community'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Meet your neighbors who have created stability through the power of affordable housing.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        stories.map(function (story, i) {
	          return _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/stories/' + story.link, className: 'col-md', key: i },
	            _react2.default.createElement(_gatsbyImage2.default, {
	              title: story.imgTitle,
	              alt: story.imgTitle,
	              sizes: story.imgSizes,
	              style: {
	                marginTop: '20px',
	                width: '100%',
	                border: '3px solid black',
	                maxHeight: '275px'
	              }
	            }),
	            _react2.default.createElement(
	              'h3',
	              { style: { textAlign: 'center', marginTop: '20px' } },
	              story.title
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return StoriesIndexPage;
	}(_react.Component);
	
	exports.default = StoriesIndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-stories-index-js-a4692d71331c919e4076.js